import RecordingInputManager from "./recording-input-manager";
import ReplayingInputManager from "./replaying-input-manager";
import Syntax from "./syntax";

export { Syntax, RecordingInputManager, ReplayingInputManager };
